export default __webpack_public_path__ + "static/media/filter_icon_entrance_blue.386d6779.svg";